export const filterPath = "<path d=\"M3.5 4.5 H12.5 L8.5 9 V12.5 L7.5 12 V9 Z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
